// extracted by mini-css-extract-plugin
export var attachment = "_ng-a";
export var emailContainer = "_ng-4";
export var emailContentPaddedContainer = "_ng-b";
export var emailHeader = "_ng-6";
export var emailIframe = "_ng-3";
export var emailInfoIcon = "_ng-9";
export var emailShortenedSummary = "_ng-e";
export var infoDropdown = "_ng-0";
export var infoRowBoundedContent = "_ng-d";
export var internal = "_ng-5";
export var merchant = "_ng-8";
export var messageInputContainer = "_ng-h";
export var normal = "_ng-7";
export var replyCard = "_ng-f";
export var subtleButton = "_ng-1";
export var subtleButtonIconContainer = "_ng-2";
export var toggleViewRepliesButton = "_ng-c";
export var wrappingText = "_ng-g";